module.exports = __webpack_public_path__ + "img/give-it-up-for-good.b8f2cacd.png";